import React from 'react';
import Tippy from '@tippyjs/react';

import { Heading, Loader } from '../../designSystem/DesignSystem';
import EntityActionButtonGroup from './EntityActionButtonGroup';
import { getEntityName } from '../../helpers/EntityHelper';

const EntityDetails = (props) => {
  const {
    data,
    users,
    loading,
    entityType,
    submitCallBack,
    submitCallBackAfterDeletion,
    submitCallBackAfterClone,
    submitCallBackVersion,
    extraButtons,
    closeModal,
    jiraConfig,
    appLogo,
    appLink,
    appTooltip
  } = props;

  const entityName = getEntityName(data, entityType);

  const calculateHeadingType = (string) => {
    if (string.length > 160) return 'small';
    if (string.length > 100) return 'base';
    return 'medium';
  };

  const renderEntityNameWithLogo = () => {
    return (
      <div className="flex items-center">
        <span>{entityName}</span>
        {appLogo && appLink && (
          <Tippy
            theme="custom-theme"
            content={appTooltip}
            animation="scale-extreme"
            placement="right"
          >
            <a
              href={appLink}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2"
            >
              <img
                src={appLogo}
                alt={appTooltip}
                className="h-5 w-auto transition duration-300 ease-in-out hover:brightness-75 hover:shadow-md hover:scale-110"
              />
            </a>
          </Tippy>
        )}
      </div>
    );
  };

  return (
    <>
      {!loading ? (
        <div>
          <Heading.Group
            text={appLogo ? renderEntityNameWithLogo() : entityName}
            isNotBold={true}
            type={calculateHeadingType(entityName)}
          >
            <EntityActionButtonGroup
              data={data}
              users={users}
              extraButtons={extraButtons}
              entityType={entityType}
              submitCallBack={submitCallBack}
              submitCallBackAfterDeletion={submitCallBackAfterDeletion}
              submitCallBackAfterClone={submitCallBackAfterClone}
              submitCallBackVersion={submitCallBackVersion}
              closeModal={closeModal}
              jiraConfig={jiraConfig}
            />
          </Heading.Group>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default EntityDetails;
